export type ListingCategoryStyle = {
  icon: string;
  color: string;
};

export const LISTING_CATEGORIES = [
  '工程擾動',
  '水質污染',
  '河川構造物',
  '河溪樣貌',
  '其它事件',
] as const;

export type ListingCategory = (typeof LISTING_CATEGORIES)[number];

export const STYLE_BY_CATEGORY: Record<ListingCategory, ListingCategoryStyle> = {
  '工程擾動': { icon: 'la-hard-hat', color: '#d03532' },
  '水質污染': { icon: 'la-tint', color: '#9a30d9' },
  '河川構造物': { icon: 'la-wave-square', color: '#64c568' },
  '河溪樣貌': { icon: 'la-seedling', color: '#25b2ec' },
  '其它事件': { icon: 'la-plus-circle', color: '#ff69b4' },
};

const DEFAULT_STYLE: ListingCategoryStyle = { icon: 'la-seedling', color: '#25b2ec' };

export const getListingCategoryStyle = (category?: string): ListingCategoryStyle => {
  if (!category) return DEFAULT_STYLE;
  return (
    (STYLE_BY_CATEGORY as Record<string, ListingCategoryStyle>)[category] ?? DEFAULT_STYLE
  );
};

export const getListingCategoryIcon = (category?: string): string =>
  getListingCategoryStyle(category).icon;
